import { POI_PAYMENT_TYPES } from '../constants/services';
import { DOMAIN } from '../domain/main';

const isTaipeiCityParkinglots = (data: any) => {
  return data.collectionIds.includes(DOMAIN.COLLECTION_ID.TAIPEI_PARKING);
};

const getPoiPaymentType = (poi: any) => {
  return poi.type === 'GasStation'
    ? getGasStationPaymentType(poi)
    : getParkinglotAndChainStorePaymentType(poi);
};

const getParkinglotAndChainStorePaymentType = (poi: any) => {
  if (poi.isSupportBarcodePayment) return POI_PAYMENT_TYPES.BARCODE_PAYMENT;
  if (poi.isSupportMochiPass) return POI_PAYMENT_TYPES.PASS;
  if (isInCooperate(poi)) return POI_PAYMENT_TYPES.MOCHIPAY;
  return POI_PAYMENT_TYPES.NONE;
};

const getGasStationPaymentType = (poi: any) => {
  if (checkIsGasStationSupportMochipassService(poi))
    return POI_PAYMENT_TYPES.PASS;
  if (checkIsGasStationSupportMochipayService(poi))
    return POI_PAYMENT_TYPES.MOCHIPAY;
  if (checkIsGasStationSupportBarcodeService(poi))
    return POI_PAYMENT_TYPES.BARCODE_PAYMENT;
  return POI_PAYMENT_TYPES.NONE;
};

const checkIsGasStationSupportMochipayService = (poi: any) =>
  poi.supportRefuelingServices.includes('mochipay');

const checkIsGasStationSupportBarcodeService = (poi: any) =>
  poi.supportRefuelingServices.includes('barcode');

const checkIsGasStationSupportMochipassService = (poi: any) =>
  poi.supportRefuelingServices.includes('mochipass');

const getPoiPaymentName = (poi: any) => {
  switch (getPoiPaymentType(poi)) {
    case POI_PAYMENT_TYPES.BARCODE_PAYMENT:
      return '條碼付';
    case POI_PAYMENT_TYPES.PASS:
      return '快速通';
    case POI_PAYMENT_TYPES.MOCHIPAY:
      return '麻吉付';
    default:
      return '不支援';
  }
};

const isInCooperate = (data: any) => {
  if (!data) return false;
  return data.cooperationState === 'in_cooperated';
};

const isGasStationBarcodePayment = (poi: any) =>
  getPoiPaymentType(poi) === POI_PAYMENT_TYPES.BARCODE_PAYMENT;
const isGasStationPass = (poi: any) =>
  getPoiPaymentType(poi) === POI_PAYMENT_TYPES.PASS;
const isGasStationMochipay = (poi: any) =>
  getPoiPaymentType(poi) === POI_PAYMENT_TYPES.MOCHIPAY;

export {
  isTaipeiCityParkinglots,
  getPoiPaymentType,
  getPoiPaymentName,
  isInCooperate,
  isGasStationBarcodePayment,
  isGasStationPass,
  isGasStationMochipay,
};
